var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemoveIcon8(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.262,
    height: 10.263,
    viewBox: "0 0 10.262 10.263",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "remove_icon_8",
    transform: "translate(-5724.833 -3194.833)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_25",
    "data-name": "\\uC120 25",
    x2: 11.313,
    transform: "translate(5725.964 3203.964) rotate(-45)",
    fill: "none",
    stroke: "#9ac3c6",
    strokeLinecap: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_26",
    "data-name": "\\uC120 26",
    x2: 11.313,
    transform: "translate(5725.964 3195.964) rotate(45)",
    fill: "none",
    stroke: "#9ac3c6",
    strokeLinecap: "round",
    strokeWidth: 1.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveIcon8);
export default __webpack_public_path__ + "static/media/remove_icon_8.aa898d2047e7031c663465b0e948a5a5.svg";
export { ForwardRef as ReactComponent };